module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "login-container"
  }, [_c('el-header', [_c('h2', {
    staticClass: "title"
  }, [_vm._v("注册")])]), _vm._v(" "), _c('el-main', [_c('el-form', {
    ref: "addForm",
    attrs: {
      "label-position": "right",
      "model": _vm.addForm,
      "label-width": "110px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "用户名",
      "prop": "user.userName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.check_zh($event)
      }
    },
    model: {
      value: (_vm.addForm.user.userName),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "userName", $$v)
      },
      expression: "addForm.user.userName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "真实姓名",
      "prop": "user.realName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.user.realName),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "realName", $$v)
      },
      expression: "addForm.user.realName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "昵称",
      "prop": "user.nickName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.user.nickName),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "nickName", $$v)
      },
      expression: "addForm.user.nickName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "密码",
      "prop": "user.password"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "type": "password"
    },
    model: {
      value: (_vm.addForm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "password", $$v)
      },
      expression: "addForm.user.password"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "确认密码",
      "prop": "user.confirmPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "type": "password"
    },
    model: {
      value: (_vm.addForm.user.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "confirmPassword", $$v)
      },
      expression: "addForm.user.confirmPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "证件类型",
      "prop": "user.certType"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.user.certType),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "certType", $$v)
      },
      expression: "addForm.user.certType"
    }
  }, _vm._l((_vm.dictCertType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "证件号码",
      "prop": "user.certNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.user.certNo),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "certNo", $$v)
      },
      expression: "addForm.user.certNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "手机号",
      "prop": "user.mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.user.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "mobile", $$v)
      },
      expression: "addForm.user.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "邮箱",
      "prop": "user.email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "email", $$v)
      },
      expression: "addForm.user.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "性别",
      "prop": "user.sex"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.user.sex),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "sex", $$v)
      },
      expression: "addForm.user.sex"
    }
  }, _vm._l((_vm.dictSex), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "市级区县",
      "prop": "org.level"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectcode1
    },
    model: {
      value: (_vm.addForm.org.level1),
      callback: function($$v) {
        _vm.$set(_vm.addForm.org, "level1", $$v)
      },
      expression: "addForm.org.level1"
    }
  }, _vm._l((_vm.items1), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectcode2
    },
    model: {
      value: (_vm.addForm.org.level2),
      callback: function($$v) {
        _vm.$set(_vm.addForm.org, "level2", $$v)
      },
      expression: "addForm.org.level2"
    }
  }, _vm._l((_vm.items2), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectcode3
    },
    model: {
      value: (_vm.addForm.org.level3),
      callback: function($$v) {
        _vm.$set(_vm.addForm.org, "level3", $$v)
      },
      expression: "addForm.org.level3"
    }
  }, _vm._l((_vm.items3), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "机构名称",
      "prop": "org.name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.org.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm.org, "name", $$v)
      },
      expression: "addForm.org.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "clear-margin-bottom",
    attrs: {
      "label": "机构类型",
      "prop": "org.type"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.org.type),
      callback: function($$v) {
        _vm.$set(_vm.addForm.org, "type", $$v)
      },
      expression: "addForm.org.type"
    }
  }, _vm._l((_vm.dictOrgType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "责任人",
      "prop": "detail.leader"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.leader),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "leader", $$v)
      },
      expression: "addForm.detail.leader"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人姓名",
      "prop": "detail.contact"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.contact),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "contact", $$v)
      },
      expression: "addForm.detail.contact"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人手机号",
      "prop": "detail.mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "mobile", $$v)
      },
      expression: "addForm.detail.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "机构地址",
      "prop": "detail.address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "address", $$v)
      },
      expression: "addForm.detail.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "场所建筑面积",
      "prop": "detail.xiaoFangArea"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangArea),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangArea", _vm._n($$v))
      },
      expression: "addForm.detail.xiaoFangArea"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "使用层数",
      "prop": "detail.xiaoFangUseNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "地上、地下"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangUseNumber),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangUseNumber", _vm._n($$v))
      },
      expression: "addForm.detail.xiaoFangUseNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "建筑结构",
      "prop": "detail.xiaoFangBuildingStructure"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangBuildingStructure),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangBuildingStructure", $$v)
      },
      expression: "addForm.detail.xiaoFangBuildingStructure"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("消防验收/备案情况")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label-width": "155px",
      "label": "是否依法通过消防验收",
      "prop": "detail.xiaoFangYanShou"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangYanShou),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangYanShou", $$v)
      },
      expression: "addForm.detail.xiaoFangYanShou"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangYanShou),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangYanShou", $$v)
      },
      expression: "addForm.detail.xiaoFangYanShou"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.addForm.detail.xiaoFangYanShou == '1') ? _c('el-form-item', {
    attrs: {
      "label-width": "50px",
      "label": "文号",
      "prop": "detail.xiaoFangYanShouWenHao"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangYanShouWenHao),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangYanShouWenHao", $$v)
      },
      expression: "addForm.detail.xiaoFangYanShouWenHao"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "210px",
      "label": "是否依法进行竣工验收消防备案",
      "prop": "detail.xiaoFangBeiAn"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangBeiAn),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangBeiAn", $$v)
      },
      expression: "addForm.detail.xiaoFangBeiAn"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangBeiAn),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangBeiAn", $$v)
      },
      expression: "addForm.detail.xiaoFangBeiAn"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.addForm.detail.xiaoFangBeiAn == '1') ? _c('el-form-item', {
    attrs: {
      "label-width": "50px",
      "label": "文号",
      "prop": "detail.xiaoFangBeiAnWenHao"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangBeiAnWenHao),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangBeiAnWenHao", $$v)
      },
      expression: "addForm.detail.xiaoFangBeiAnWenHao"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "420px",
      "label": "建筑总平面布局、防火间距、消防车通道等是否符合消防技术标准",
      "prop": "detail.xiaoFangJiShu"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangJiShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangJiShu", $$v)
      },
      expression: "addForm.detail.xiaoFangJiShu"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangJiShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangJiShu", $$v)
      },
      expression: "addForm.detail.xiaoFangJiShu"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "167px",
      "label": "是否违规采用彩钢板搭建",
      "prop": "detail.xiaoFangCaiGang"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangCaiGang),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangCaiGang", $$v)
      },
      expression: "addForm.detail.xiaoFangCaiGang"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangCaiGang),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangCaiGang", $$v)
      },
      expression: "addForm.detail.xiaoFangCaiGang"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "237px",
      "label": "是否违规使用可燃易燃材料装修装饰",
      "prop": "detail.xiaoFangKeRanYiRan"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangKeRanYiRan),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangKeRanYiRan", $$v)
      },
      expression: "addForm.detail.xiaoFangKeRanYiRan"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangKeRanYiRan),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangKeRanYiRan", $$v)
      },
      expression: "addForm.detail.xiaoFangKeRanYiRan"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "196px",
      "label": "是否违规存放易燃易爆危险品",
      "prop": "detail.xiaoFangYiRanYiBao"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangYiRanYiBao),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangYiRanYiBao", $$v)
      },
      expression: "addForm.detail.xiaoFangYiRanYiBao"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangYiRanYiBao),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangYiRanYiBao", $$v)
      },
      expression: "addForm.detail.xiaoFangYiRanYiBao"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "114px",
      "label": "防火分隔不到位",
      "prop": "detail.xiaoFangFangHuoFenGe"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangFangHuoFenGe),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangFangHuoFenGe", $$v)
      },
      expression: "addForm.detail.xiaoFangFangHuoFenGe"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangFangHuoFenGe),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangFangHuoFenGe", $$v)
      },
      expression: "addForm.detail.xiaoFangFangHuoFenGe"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "212px",
      "label": "电器线路是否采取防火保护措施",
      "prop": "detail.xiaoFangFangHuoBaoHu"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangFangHuoBaoHu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangFangHuoBaoHu", $$v)
      },
      expression: "addForm.detail.xiaoFangFangHuoBaoHu"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangFangHuoBaoHu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangFangHuoBaoHu", $$v)
      },
      expression: "addForm.detail.xiaoFangFangHuoBaoHu"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "130px",
      "label": "消防设施损坏停用",
      "prop": "detail.xiaoFangSheShiSunHuai"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangSheShiSunHuai),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangSheShiSunHuai", $$v)
      },
      expression: "addForm.detail.xiaoFangSheShiSunHuai"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangSheShiSunHuai),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangSheShiSunHuai", $$v)
      },
      expression: "addForm.detail.xiaoFangSheShiSunHuai"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "299px",
      "label": "建筑消防设施设置是否符合消防技术标准要求",
      "prop": "detail.xiaoFangFuHeJiShu"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangFuHeJiShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangFuHeJiShu", $$v)
      },
      expression: "addForm.detail.xiaoFangFuHeJiShu"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangFuHeJiShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangFuHeJiShu", $$v)
      },
      expression: "addForm.detail.xiaoFangFuHeJiShu"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "188px",
      "label": "本单位主要的消防设施有：",
      "prop": "detail.xiaoFangSheShi"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.addForm.detail.xiaoFangSheShi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangSheShi", $$v)
      },
      expression: "addForm.detail.xiaoFangSheShi"
    }
  }, _vm._l((_vm.sheshis), function(sheshi) {
    return _c('el-checkbox', {
      key: sheshi.value,
      attrs: {
        "label": sheshi.value
      }
    }, [_vm._v(_vm._s(sheshi.name))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "218px",
      "label": "消防设施器材是否保持完好有效",
      "prop": "detail.xiaoFangSheShiYouXiao"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangSheShiYouXiao),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangSheShiYouXiao", $$v)
      },
      expression: "addForm.detail.xiaoFangSheShiYouXiao"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangSheShiYouXiao),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangSheShiYouXiao", $$v)
      },
      expression: "addForm.detail.xiaoFangSheShiYouXiao"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [(_vm.addForm.detail.xiaoFangSheShiYouXiao == '0') ? _c('el-form-item', {
    attrs: {
      "label-width": "136px",
      "label": "有故障的消防设施",
      "prop": "detail.xiaoFangGuZhangSheShi"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangGuZhangSheShi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangGuZhangSheShi", $$v)
      },
      expression: "addForm.detail.xiaoFangGuZhangSheShi"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "206px",
      "label": "电动自行车是否违规停放充电",
      "prop": "detail.xiaoFangZiXingChe"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangZiXingChe),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangZiXingChe", $$v)
      },
      expression: "addForm.detail.xiaoFangZiXingChe"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangZiXingChe),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangZiXingChe", $$v)
      },
      expression: "addForm.detail.xiaoFangZiXingChe"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "136px",
      "label": "是否违规动火用电",
      "prop": "detail.xiaoFangHuoDian"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangHuoDian),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangHuoDian", $$v)
      },
      expression: "addForm.detail.xiaoFangHuoDian"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangHuoDian),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangHuoDian", $$v)
      },
      expression: "addForm.detail.xiaoFangHuoDian"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "360px",
      "label": "是否签订维保合同，并按规定对消防设施进行维修保养",
      "prop": "detail.xiaoFangWeiBaoHeTong"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangWeiBaoHeTong),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangWeiBaoHeTong", $$v)
      },
      expression: "addForm.detail.xiaoFangWeiBaoHeTong"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangWeiBaoHeTong),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangWeiBaoHeTong", $$v)
      },
      expression: "addForm.detail.xiaoFangWeiBaoHeTong"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "472px",
      "label": "消防设施器材是否设置规范醒目的标识，用文字或图例标明操作使用方法",
      "prop": "detail.xiaoFangSheZhiXingMuBiaoShi"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangSheZhiXingMuBiaoShi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangSheZhiXingMuBiaoShi", $$v)
      },
      expression: "addForm.detail.xiaoFangSheZhiXingMuBiaoShi"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangSheZhiXingMuBiaoShi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangSheZhiXingMuBiaoShi", $$v)
      },
      expression: "addForm.detail.xiaoFangSheZhiXingMuBiaoShi"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "342px",
      "label": "是否存在占用、堵塞、锁闭疏散通道和安全出口行为",
      "prop": "detail.xiaoFangAnQuanChuKou"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangAnQuanChuKou),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangAnQuanChuKou", $$v)
      },
      expression: "addForm.detail.xiaoFangAnQuanChuKou"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangAnQuanChuKou),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangAnQuanChuKou", $$v)
      },
      expression: "addForm.detail.xiaoFangAnQuanChuKou"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "370px",
      "label": "是否在门窗上设置影响逃生和灭火救援的铁柵栏、障碍物",
      "prop": "detail.xiaoFangZhangAiWu"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangZhangAiWu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangZhangAiWu", $$v)
      },
      expression: "addForm.detail.xiaoFangZhangAiWu"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangZhangAiWu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangZhangAiWu", $$v)
      },
      expression: "addForm.detail.xiaoFangZhangAiWu"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "384px",
      "label": "是否落实消防安全主体责任，确定消防安全责任人、管理人",
      "prop": "detail.xiaoFangLuoShi"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangLuoShi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangLuoShi", $$v)
      },
      expression: "addForm.detail.xiaoFangLuoShi"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangLuoShi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangLuoShi", $$v)
      },
      expression: "addForm.detail.xiaoFangLuoShi"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "314px",
      "label": "是否制定落实消防安全制度并面向全体员工公布",
      "prop": "detail.xiaoFangLuoShiYuanGong"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangLuoShiYuanGong),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangLuoShiYuanGong", $$v)
      },
      expression: "addForm.detail.xiaoFangLuoShiYuanGong"
    }
  }, [_vm._v("已制定")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangLuoShiYuanGong),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangLuoShiYuanGong", $$v)
      },
      expression: "addForm.detail.xiaoFangLuoShiYuanGong"
    }
  }, [_vm._v("已制定但内容不全")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangLuoShiYuanGong),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangLuoShiYuanGong", $$v)
      },
      expression: "addForm.detail.xiaoFangLuoShiYuanGong"
    }
  }, [_vm._v("未制定")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangLuoShiYuanGong),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangLuoShiYuanGong", $$v)
      },
      expression: "addForm.detail.xiaoFangLuoShiYuanGong"
    }
  }, [_vm._v("未公布")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "258px",
      "label": "是否制定符合消防安全要求的操作规程",
      "prop": "detail.xiaoFangAnQuanGuiFan"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangAnQuanGuiFan),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangAnQuanGuiFan", $$v)
      },
      expression: "addForm.detail.xiaoFangAnQuanGuiFan"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangAnQuanGuiFan),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangAnQuanGuiFan", $$v)
      },
      expression: "addForm.detail.xiaoFangAnQuanGuiFan"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "314px",
      "label": "是否制定灭火和应急疏散预案，并组织消防演练",
      "prop": "detail.xiaoFangYanXi"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangYanXi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangYanXi", $$v)
      },
      expression: "addForm.detail.xiaoFangYanXi"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangYanXi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangYanXi", $$v)
      },
      expression: "addForm.detail.xiaoFangYanXi"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.addForm.detail.xiaoFangYanXi == '1') ? _c('el-form-item', {
    attrs: {
      "label-width": "120px",
      "label": "消防演练次数",
      "prop": "detail.xiaoFangYanXiCiShu"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangYanXiCiShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangYanXiCiShu", _vm._n($$v))
      },
      expression: "addForm.detail.xiaoFangYanXiCiShu"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "412px",
      "label": "是否按排查整治标准定期进行防火检查、巡查，并填写检查记录",
      "prop": "detail.xiaoFangJianCha"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangJianCha),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangJianCha", $$v)
      },
      expression: "addForm.detail.xiaoFangJianCha"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangJianCha),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangJianCha", $$v)
      },
      expression: "addForm.detail.xiaoFangJianCha"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "315px",
      "label": "是否组织员工进行岗前和定期消防安全教育培训",
      "prop": "detail.xiaoFangPeiXun"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangPeiXun),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangPeiXun", $$v)
      },
      expression: "addForm.detail.xiaoFangPeiXun"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangPeiXun),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangPeiXun", $$v)
      },
      expression: "addForm.detail.xiaoFangPeiXun"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.addForm.detail.xiaoFangPeiXun == '1') ? _c('el-form-item', {
    attrs: {
      "label-width": "120px",
      "label": "已培训员工数",
      "prop": "detail.xiaoFangPeiXunRenShu"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangPeiXunRenShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangPeiXunRenShu", _vm._n($$v))
      },
      expression: "addForm.detail.xiaoFangPeiXunRenShu"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "315px",
      "label": "消防控制室值班人员是否经过培训，并持证上岗",
      "prop": "detail.xiaoFangChiZheng"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangChiZheng),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangChiZheng", $$v)
      },
      expression: "addForm.detail.xiaoFangChiZheng"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangChiZheng),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangChiZheng", $$v)
      },
      expression: "addForm.detail.xiaoFangChiZheng"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.addForm.detail.xiaoFangChiZheng == '1') ? _c('el-form-item', {
    attrs: {
      "label-width": "120px",
      "label": "持证上岗人数",
      "prop": "detail.xiaoFangChiZhengRenShu"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangChiZhengRenShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangChiZhengRenShu", _vm._n($$v))
      },
      expression: "addForm.detail.xiaoFangChiZhengRenShu"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "217px",
      "label": "员工是否掌握岗位消防安全知识",
      "prop": "detail.xiaoFangAnQuanZhiShi"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangAnQuanZhiShi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangAnQuanZhiShi", $$v)
      },
      expression: "addForm.detail.xiaoFangAnQuanZhiShi"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangAnQuanZhiShi),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangAnQuanZhiShi", $$v)
      },
      expression: "addForm.detail.xiaoFangAnQuanZhiShi"
    }
  }, [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "260px",
      "label": "单位是否建立专职消防队或志愿消防队",
      "prop": "detail.xiaoFangXiaoFangDui"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangXiaoFangDui),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangXiaoFangDui", $$v)
      },
      expression: "addForm.detail.xiaoFangXiaoFangDui"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangXiaoFangDui),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangXiaoFangDui", $$v)
      },
      expression: "addForm.detail.xiaoFangXiaoFangDui"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.addForm.detail.xiaoFangXiaoFangDui == '1') ? _c('el-form-item', {
    attrs: {
      "label-width": "136px",
      "label": "专职消防队人数",
      "prop": "detail.xiaoFangXiaoFangDuiRenShu"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangXiaoFangDuiRenShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangXiaoFangDuiRenShu", _vm._n($$v))
      },
      expression: "addForm.detail.xiaoFangXiaoFangDuiRenShu"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [(_vm.addForm.detail.xiaoFangXiaoFangDui == '1') ? _c('el-form-item', {
    attrs: {
      "label-width": "160px",
      "label": "志愿消防队人数",
      "prop": "detail.xiaoFangZhiYuanXiaoFangDuiRenShu"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangZhiYuanXiaoFangDuiRenShu),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangZhiYuanXiaoFangDuiRenShu", _vm._n($$v))
      },
      expression: "addForm.detail.xiaoFangZhiYuanXiaoFangDuiRenShu"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "76px",
      "label": "其他情况",
      "prop": "detail.xiaoFangRemarks"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.detail.xiaoFangRemarks),
      callback: function($$v) {
        _vm.$set(_vm.addForm.detail, "xiaoFangRemarks", $$v)
      },
      expression: "addForm.detail.xiaoFangRemarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "user.sidentify",
      "label-width": "64px",
      "label": "验证码"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.addForm.user.sidentify),
      callback: function($$v) {
        _vm.$set(_vm.addForm.user, "sidentify", $$v)
      },
      expression: "addForm.user.sidentify"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.url1
    },
    on: {
      "click": _vm.chang_url
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleAgree($event)
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleDisAgree($event)
      }
    }
  }, [_vm._v("后退   ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-310b4102"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reg.vue
// module id = 1160
// module chunks = 2